import './src/polyfill';

import { enableExperimentalWebImplementation } from 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import '@/app/core/setup';
import App from '@/app/App';
import React from 'react';
enableExperimentalWebImplementation();
registerRootComponent(App);
